module.exports = __webpack_public_path__ + "media/images/martinique-bc114f4b2c31d8abab96f896f9021245.svg";